import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import userIcon from "../../../assets/avatar.png"; // Default user icon
import { courseReview, myReview } from "../../../slices/courseSlice";
import StarRating from "../../../components/starRating";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../../../components/spinner";
import { formatTimestamp } from "../../../common/timeStampConverter";

const MyReview = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.auth.userInfo);
    const { myReviewList, loading, error } = useSelector((state) => state.course);
    const [reviews, setReviews] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(7);
    const [timeZone, setTimeZone] = useState('');

    useEffect(() => {
      // Get the user's timezone when the component mounts
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setTimeZone(userTimeZone);
    }, []);    

    useEffect(() => {
        dispatch(myReview({ page, limit, trainer_id: userInfo?.id }));
    }, [dispatch, page, limit]);

    useEffect(() => {
        if (myReviewList?.data?.length > 0) {
            setReviews((prevReviews) => [...prevReviews, ...myReviewList.data]);
            setHasMore(myReviewList.data.length >= limit);
        } else {
            setHasMore(false);
        }
        return () => {
            setReviews([]);
        }
    }, [myReviewList, limit]);

    const fetchMoreReviews = () => {
        setPage((prevPage) => prevPage + 1);
    };

    return (
        <>
            <Helmet>
                <title>LEA.TRAINING | My Reviews</title>
            </Helmet>

            <div className="content-page">
                <div className="col-md-12 col-xl-12 mt-1">
                    <div className="widget-rounded-circle card">
                        <div className="card-body px-4">
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "10px" }}>
                                <h3 className="text-info text-capitalize">My Reviews</h3>
                            </div>
                            {
                                reviews?.length > 0 ? (
                                    <InfiniteScroll
                                        dataLength={reviews?.length}
                                        next={fetchMoreReviews}
                                        hasMore={hasMore}
                                        loader={<Spinner />}
                                        endMessage={<p style={{ textAlign: "center" }}>No more reviews</p>}
                                        style={{overflow:"inherit",height:"auto"}}
                                    >
                                        <div className="review-list">
                                            {reviews?.map((review) => (
                                                <div key={review?.id} className="review-item card mb-3">
                                                    <div className="row align-items-center">
                                                        <div className="col-9 d-flex align-items-center">
                                                            <img
                                                                src={review?.user_trainer_review?.image || userIcon}
                                                                alt={review?.user_trainer_review?.full_name || "User"}
                                                                className="rounded-circle"
                                                                style={{ width: '50px', height: '50px', marginRight: '10px' }}
                                                            />
                                                            <div>
                                                                <h5 className="mb-0">{review?.user_trainer_review?.full_name || "Anonymous User"}</h5>
                                                                <div className="rating" style={{ color: '#ffc107' }}>
                                                                    <StarRating rating={review?.rating} />
                                                                </div>  
                                                                <small className="text-muted">
                                                                    {formatTimestamp(review?.review_date,"ddd, D MMM [at] HH:mm",timeZone)}
                                                                    {/* {review?.review_date ? moment.utc(review?.review_date).format("ddd, D MMM [at] HH:mm") : "Date not available"} */}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-12">
                                                            <p>{review?.review || "No review provided"}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </InfiniteScroll>
                                ) : (
                                    <p className="text-center mt-3">There are no reviews at this moment.</p>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MyReview;